import { CircleHelp } from "lucide-react";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";

interface CompactHintTriggerProps {
  text: string;
  label: string;
}

export function CompactHintTrigger({ text, label }: CompactHintTriggerProps) {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          type="button"
          className="compact-hint-trigger inline-grid size-3.5 place-items-center border-0 bg-transparent p-0 text-muted-foreground hover:text-foreground"
          aria-label={`Ayuda: ${label}`}
        >
          <CircleHelp className="h-3 w-3" aria-hidden />
        </button>
      </PopoverTrigger>
      <PopoverContent
        side="top"
        align="center"
        collisionPadding={8}
        className="w-auto max-w-[min(20rem,calc(100vw-2rem))] p-3 text-left text-xs leading-relaxed"
      >
        {text}
      </PopoverContent>
    </Popover>
  );
}
